import React from 'react';
import * as Styled from './Steps.styled';

interface OwnProps {
  step: number;
  title: string;
}

const Step: ReactFCWithChildren<OwnProps> = ({ step, title, children }) => {
  return (
    <Styled.StepWrapper>
      <Styled.Step>{step}</Styled.Step>
      <Styled.DescriptionWrapper>
        <Styled.TitleStep>{title}</Styled.TitleStep>
        {children}
      </Styled.DescriptionWrapper>
    </Styled.StepWrapper>
  );
};

export default Step;
